import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { QueryProvider, AuthProvider } from './providers';
import { QuickAccessProvider } from '@/shared/contexts/QuickAccessContext';
import { SettingsProvider } from '@/shared/contexts/SettingsContext';
import { AdminHeader } from '@/shared/components/layout';
import { AppRoutes } from '@/routes';
import { ErrorBoundary } from '@/shared/components/ui/ErrorBoundary';

function AppLayout() {
  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-50 dark:bg-gray-900">
      <AdminHeader />
      <main className="flex-1 min-w-0 overflow-y-auto">
        <AppRoutes />
      </main>
    </div>
  );
}

export function App() {
  return (
    <Provider store={store}>
      <QueryProvider>
        <BrowserRouter>
          <AuthProvider>
            <SettingsProvider>
              <QuickAccessProvider>
                <ErrorBoundary>
                  <AppLayout />
                </ErrorBoundary>
              </QuickAccessProvider>
            </SettingsProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </Provider>
  );
}

export default App;
